var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import apiClient from '@utils/api-client';
import { apiInternalVisitsPath, apiInternalTimeOffsPath, apiInternalHolidaysPath, apiInternalGenericEventsPath } from '../../../routes';
/** Statuses filter from React header (`*Keys`) or legacy Kendo multi-select fields (IP-13256). */
function inspectionStatusesForApi(values) {
    var _a;
    if ((_a = values.inspectionStatusKeys) === null || _a === void 0 ? void 0 : _a.length)
        return [...values.inspectionStatusKeys];
    const raw = values.inspectionStatus;
    if (Array.isArray(raw))
        return raw.filter((x) => x != null && x !== '').map(String);
    if (typeof raw === 'string' && raw !== '')
        return [raw];
    return [];
}
function visitStatusesForApi(values) {
    var _a;
    if ((_a = values.visitStatusKeys) === null || _a === void 0 ? void 0 : _a.length)
        return [...values.visitStatusKeys];
    const raw = values.visitStatus;
    if (Array.isArray(raw))
        return raw.filter((x) => x != null && x !== '').map(String);
    if (typeof raw === 'string' && raw !== '')
        return [raw];
    return [];
}
export function getCalendarVisits(params, signal) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        try {
            const response = yield apiClient.get(apiInternalVisitsPath(), {
                params: {
                    select: 'all',
                    view: 'calendar',
                    calendarView: params.view,
                    filter: {
                        type: ((_b = (_a = params.filters) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.type) ? [params.filters.values.type] : undefined,
                        range: {
                            start: params.range.start.toISOString(),
                            end: params.range.end.toISOString()
                        },
                        buildingIds: ((_d = (_c = params.filters) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.building) || undefined,
                        assets: ((_f = (_e = params.filters) === null || _e === void 0 ? void 0 : _e.values) === null || _f === void 0 ? void 0 : _f.asset) || undefined,
                        teamIds: ((_h = (_g = params.filters) === null || _g === void 0 ? void 0 : _g.values) === null || _h === void 0 ? void 0 : _h.technicianTeam) || undefined,
                        technicianIds: params.selectedTechnicianIds.map((id) => (id === null ? 'unassigned' : id)),
                        subcontractorIds: params.selectedSubcontractorIds.map((id) => (id === null ? 'unassigned' : id)),
                        territoryIds: ((_k = (_j = params.filters) === null || _j === void 0 ? void 0 : _j.values) === null || _k === void 0 ? void 0 : _k.territory) || undefined,
                        additionalTerritoryIds: ((_m = (_l = params.filters) === null || _l === void 0 ? void 0 : _l.values) === null || _m === void 0 ? void 0 : _m.additionalTerritory) || undefined,
                        tagIds: ((_p = (_o = params.filters) === null || _o === void 0 ? void 0 : _o.values) === null || _p === void 0 ? void 0 : _p.tags) || undefined,
                        buildingTagIds: ((_r = (_q = params.filters) === null || _q === void 0 ? void 0 : _q.values) === null || _r === void 0 ? void 0 : _r.buildingTags) || undefined,
                        accountTagIds: ((_t = (_s = params.filters) === null || _s === void 0 ? void 0 : _s.values) === null || _t === void 0 ? void 0 : _t.accountTags) || undefined,
                        workOrderTagIds: ((_v = (_u = params.filters) === null || _u === void 0 ? void 0 : _u.values) === null || _v === void 0 ? void 0 : _v.workOrderTags) || undefined,
                        inspectionTypeIds: ((_x = (_w = params.filters) === null || _w === void 0 ? void 0 : _w.values) === null || _x === void 0 ? void 0 : _x.inspectionType) || undefined,
                        inspectionStatuses: inspectionStatusesForApi(params.filters.values),
                        visitStatuses: visitStatusesForApi(params.filters.values),
                        accountIds: ((_z = (_y = params.filters) === null || _y === void 0 ? void 0 : _y.values) === null || _z === void 0 ? void 0 : _z.account) || undefined
                    }
                },
                signal
            });
            return {
                data: {
                    visits: response.data.data,
                    pagination: response.data.pagination
                }
            };
        }
        catch (error) {
            if (isAbortError(error)) {
                return { error: { message: 'Request cancelled' } };
            }
            return {
                error: {
                    message: getErrorMessage(error, 'Failed to fetch calendar visits')
                }
            };
        }
    });
}
export function getCalendarTimeOffs(params, signal) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        try {
            const response = yield apiClient.get(apiInternalTimeOffsPath(), {
                params: {
                    select: 'all',
                    filter: {
                        technicianIds: params.selectedTechnicianIds.filter((id) => id !== null),
                        teamIds: ((_b = (_a = params.filters) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.technicianTeam) || undefined,
                        territoryIds: ((_d = (_c = params.filters) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.territory) || undefined,
                        range: {
                            start: params.range.start.toISOString(),
                            end: params.range.end.toISOString()
                        }
                    }
                },
                signal
            });
            return {
                data: { timeOffs: response.data.data }
            };
        }
        catch (error) {
            if (isAbortError(error)) {
                return { error: { message: 'Request cancelled' } };
            }
            return {
                error: {
                    message: getErrorMessage(error, 'Failed to fetch time offs')
                }
            };
        }
    });
}
export function getCalendarHolidays(params, signal) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield apiClient.get(apiInternalHolidaysPath(), {
                params: {
                    select: 'all',
                    filter: {
                        range: {
                            start: params.range.start.toISOString(),
                            end: params.range.end.toISOString()
                        }
                    }
                },
                signal
            });
            return {
                data: { holidays: response.data.data }
            };
        }
        catch (error) {
            if (isAbortError(error)) {
                return { error: { message: 'Request cancelled' } };
            }
            return {
                error: {
                    message: getErrorMessage(error, 'Failed to fetch holidays')
                }
            };
        }
    });
}
export function getCalendarGenericEvents(params, signal) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        try {
            const response = yield apiClient.get(apiInternalGenericEventsPath(), {
                params: {
                    select: 'all',
                    filter: {
                        type: ((_b = (_a = params.filters) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.type) || undefined,
                        range: {
                            start: params.range.start.toISOString(),
                            end: params.range.end.toISOString()
                        },
                        teamIds: ((_d = (_c = params.filters) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.technicianTeam) || undefined,
                        technicianIds: params.selectedTechnicianIds.map((id) => (id === null ? 'unassigned' : id))
                    }
                },
                signal
            });
            return {
                data: { genericEvents: response.data.data }
            };
        }
        catch (error) {
            if (isAbortError(error)) {
                return { error: { message: 'Request cancelled' } };
            }
            return {
                error: {
                    message: getErrorMessage(error, 'Failed to fetch generic events')
                }
            };
        }
    });
}
export function getVisitDetails(visitId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield apiClient.get(`${apiInternalVisitsPath()}/${visitId}`, {
                params: { modal: 'true' }
            });
            return { data: response.data };
        }
        catch (error) {
            return {
                error: {
                    message: getErrorMessage(error, 'Failed to fetch visit details')
                }
            };
        }
    });
}
export function updateVisit(visitId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield apiClient.patch(`${apiInternalVisitsPath()}/${visitId}`, { visit: data });
            return { data: response.data };
        }
        catch (error) {
            return {
                error: {
                    message: getErrorMessage(error, 'Failed to update visit')
                }
            };
        }
    });
}
export function updateGenericEvent(eventId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield apiClient.patch(`${apiInternalGenericEventsPath()}/${eventId}`, {
                genericEvent: data
            });
            return { data: response.data };
        }
        catch (error) {
            return {
                error: {
                    message: getErrorMessage(error, 'Failed to update generic event')
                }
            };
        }
    });
}
function isAbortError(error) {
    return error instanceof DOMException && error.name === 'AbortError';
}
function getErrorMessage(error, fallback) {
    var _a, _b;
    if (error instanceof Error) {
        return error.message;
    }
    if (typeof error === 'object' && error !== null && 'response' in error) {
        const axiosError = error;
        return ((_b = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) || fallback;
    }
    return fallback;
}
